import faker from 'faker'
import { mapGetters, mapActions } from 'vuex'
import removeConfirm from '@/components/removeConfirm.vue'
faker.locale = 'fa'
export default {
  name: 'Global',
  mixins: [faker],
  components: {
    removeConfirm
  },
  computed: {
    ...mapGetters({
      token: 'auth/token',
      userInfo: 'auth/userInfo',
      userState: 'auth/userState'
    })
  },
  methods: {
    ...mapActions({
      snackbar: 'snackbar/showToastMessage'
    }),
    getCDNURL (filePath) {
      return `${this.APP_CONFIG.cdnBaseURL}${filePath}`
    },
    addColoredLayout () {
      var el = document.getElementsByTagName('body')
      el[0].classList.add('main-layout--colored')
    },
    removeColoredLayout () {
      var el = document.getElementsByTagName('body')
      el[0].classList.remove('main-layout--colored')
    }
  }
}
